import React, { useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import LandingLayout, { Benefit, useLandingMeta } from "@/components/landing/LandingLayout";
import data from "@/lib/landing.json";

export default function OfferPage() {
  const { offer } = useParams();
  const o = data.offers.find((x) => x.slug === offer);
  const meta = useMemo(() => o && {
    title: o.title,
    description: o.description,
    jsonLd: { "@context": "https://schema.org", "@type": "Service", name: o.h1, description: o.description, provider: { "@type": "FinancialService", name: "MD Courtage", telephone: "+33688073833" }, areaServed: ["Mayenne", "Ille-et-Vilaine"] },
  }, [o]);
  useLandingMeta(meta || { title: "MD Courtage", description: "", jsonLd: {} });
  if (!o) return <Navigate to="/" replace />;

  return (
    <LandingLayout testId={`offer-page-${o.slug}`} needs={[o.need]} page={`/offre/${o.slug}`}>
      <section className="max-w-5xl mx-auto px-6 md:px-12 pt-16 pb-12 md:pt-24 text-left animate-fade-up">
        <div className="text-xs uppercase tracking-[0.25em] text-md-accent font-bold mb-5">{o.eyebrow}</div>
        <h1 data-testid="offer-h1" className="font-serif text-4xl sm:text-5xl lg:text-6xl text-md-primary font-medium leading-[1.05] mb-6 max-w-3xl">{o.h1}</h1>
        <p className="text-lg text-md-text/80 leading-relaxed max-w-2xl mb-8">{o.lead}</p>
        <div className="flex flex-wrap items-center gap-4">
          <a href="#devis" data-testid="offer-cta-quote" className="bg-md-secondary hover:bg-md-secondaryHover text-white px-8 py-4 rounded-full font-semibold shadow-lg shadow-md-secondary/30 transition-transform hover:-translate-y-0.5">Recevoir mon étude gratuite</a>
          {["Réponse sous 24h ouvrées", "Sans engagement", "Rendez-vous à domicile ou en visio"].map((t) => (
            <span key={t} className="inline-flex items-center gap-1.5 text-sm text-md-primary"><CheckCircle2 className="w-4 h-4 text-md-accent" /> {t}</span>
          ))}
        </div>
      </section>
      <section className="max-w-5xl mx-auto px-6 md:px-12 pb-12 grid md:grid-cols-3 gap-5">
        {o.benefits.map(([t, d], i) => <Benefit key={t} title={t} desc={d} i={i} />)}
      </section>
      <p data-testid="offer-notice" className="max-w-5xl mx-auto px-6 md:px-12 pb-16 text-xs text-md-muted">{o.notice}</p>
    </LandingLayout>
  );
}
